import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthorisedSubNavLink } from '../../Auth/AuthorisedSubNavLink';
import { SubNavProps } from '../SubNavLinks';

const CAMPAIGN_QUERY =
  '?Client=&Campaign+Name=&Aggregate+level=&Segment+ID+Name=&Cycle+Name=' +
  '&Time+Period+Granularity=Week&Date+Range=30+day+ago+for+30+day&Currency+Exchange=GBP';

const TEMPLATE_QUERY =
  '?Client=&Campaign+Name=&Aggregate+Level=&Segment+ID+Name=&Template+Name=' +
  '&Date+Range=30+day+ago+for+30+day&Time+Period+Granularity=Week&Currency+Exchange=GBP';

const dashboardPages = [
  { key: 'main', to: '' },
  {
    key: 'basket_abandonment',
    to: `/new_business_aggregates::basket_abandonment__campaign_aggregates${CAMPAIGN_QUERY}`,
  },
  {
    key: 'browse_abandonment',
    to: `/new_business_aggregates::browse_abandonment__campaign_aggregates${CAMPAIGN_QUERY}`,
  },
  { key: 'display_only', to: `/new_business_aggregates::display_only__campaign_aggregates${TEMPLATE_QUERY}` },
  { key: 'smb_display', to: `/new_business_aggregates::smb_display__campaign_aggregates${TEMPLATE_QUERY}` },
  { key: 'smb_email', to: `/new_business_aggregates::smb_email__campaign_aggregates${CAMPAIGN_QUERY}` },
  { key: 'dac', to: `/new_business_aggregates::dac_display__campaign_aggregates${TEMPLATE_QUERY}` },
  { key: 'dac_email', to: `/new_business_aggregates::dac_email__campaign_aggregates${CAMPAIGN_QUERY}` },
  { key: 'bulk_retargeting', to: `/new_business_aggregates::bulk_retargeting__campaign_aggregates${CAMPAIGN_QUERY}` },
];

export const createPath = (to: string): string => {
  const { pathname } = window.location;

  const siteMatch = pathname.match(/^\/sites\/([^/]+)\/dashboard/i);
  if (siteMatch) {
    return `/sites/${siteMatch[1]}/dashboard${to}`;
  }

  const brandMatch = pathname.match(/^\/brands\/([^/]+)\/dashboard/i);
  if (brandMatch) {
    return `/brands/${brandMatch[1]}/dashboard${to}`;
  }

  return to ? `/dashboard${to}` : '/';
};

export const DashboardSubNav: React.FC<SubNavProps & { path?: string }> = ({ setHeading }) => {
  const { t } = useTranslation('dashboard');

  useEffect(() => {
    setHeading(t('heading'));
  }, [setHeading, t]);

  return (
    <>
      {dashboardPages.map(({ key, to }) => (
        <AuthorisedSubNavLink
          key={key}
          permissions={['ViewDashboards']}
          to={createPath(to)}
          icon="chart-line"
          exact
          label={t(`dashboards.${key}.label`)}
        />
      ))}
    </>
  );
};
